export enum IconNodeType {
  Sector = 'sectors-icons',
  Subsector = 'subsectors-icons',
  TransitionElement = 'transition-elements-icons',
}
